import { graphql } from 'relay-runtime';

export const currentStudentSkillQuery = graphql`
  query SingleSkillQuery($studentId: ID!, $filter: SkillAssessmentsByStudentFilterInput) {
    skillAssessmentsByStudentId(studentId: $studentId, filter: $filter) {
      nodes {
        activityId
        skill {
          id
        }
        score
        sessionCompletedOn
      }
    }
  }
`;
